import { Button, CircularProgress } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Http from "../../../Http";

export default function ConsultaSaldoFacturista() {
  const [loading, setLoading] = useState(true);
  const [saldo, setSaldo] = useState({
    contratados: 0,
    disponibles: 0,
    usados: 0,
  });

  useEffect(() => {
    loadSaldo();
  }, []);

  const loadSaldo = async () => {
    setLoading(true);
    const Resp = await Http.get("facturacion/consulta-saldo-facturista");
    if (!Resp.error) {
      setSaldo({
        ...Resp.data,
      });
    }
    setLoading(false);
  };

  return (
    <div>
      
      <div 
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
        }}
      >
        <h2>Saldos Facturista</h2>
        <Button 
          disabled={loading}
          onClick={() => { loadSaldo() }}
          variant="outlined" 
          color='primary'>
            Recargar
        </Button>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
        }}
      >
        {!loading ? (
          <>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div>
                <h4>Contratados</h4>
              </div>
              <div>{saldo.contratados}</div>
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <div>
                <h4>Disponibles</h4>
              </div>
              <div>{saldo.disponibles}</div>
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <div>
                <h4>Usados</h4>
              </div>
              <div>{saldo.usados}</div>
            </div>
          </>
        ) : (
          <CircularProgress />
        )}
      </div>
    </div>
  );
}
